import React from "react";
import Group1 from "src/assets/images/website-images/Group 20250.png";
import Group2 from "src/assets/images/website-images/Path 42472.png";
import Group3 from "src/assets/images/website-images/Group 20252.png";
import Group4 from "src/assets/images/website-images/Group 20253.png";
import { Link } from "react-router-dom";

function UploadPrescription() {
  let dt = [
    {
      image: Group2,
      title: [ "Upload Prescription", "or Medicine Details"],
    },
    {
      image: Group3,
      title: [ "Our Pharmacist", "will assist you"],
    },
    {
      image: Group4,
      title: [ "Get Medicines", "Delivered"],
    },
  ];

  return (
    <div className="w-full p-3 bg-banner-white-image py-8">
      <div className="view-area-width">
        <h3 className="text-[#004540] flex justify-center font-size-35px font-Lexend-SemiBold mt-8">
          Getting Your Medicines Is Easy Now!
        </h3>
        <p className="text-[#2A2A2A] font-size-17px flex justify-center font-Poppins-Medium">
          Send Us A Picture Of Your Prescription Or The Medicine You Are Looking
          For
        </p>

        <div className="flex flex-col md:flex-row gap-14 justify-center mb-16 mt-12">
          <Link
            to={"/upload-prescription/valid-prescription"}
            className="w-[37%]"
            id="valid-prescription-link"
          >
            <div className="rounded-lg w-full p-2 border border-[#004B45] cursor-pointer hover:shadow-lg transition duration-300 flex justify-center">
              <div className="flex items-center gap-3 xl:gap-4">
                <div className="h-[70px] lg:h-[3.8vw] w-[70px] lg:w-[3.8vw] bg-gradient-to-b from-[#004B45] to-[#007F77] rounded-full flex justify-center items-center text-white">
                  <img src={Group1} alt="" className="h-[50%] object-contain" />
                </div>
                <div className="text-left">
                  <h3 className="font-size-22px text-[#3B3B3B] font-Lexend-Regular">
                    I have a Valid Prescription
                  </h3>
                  <p className="font-size-14px text-[#3B3B3B] font-Poppins-Regular">
                    Upload Insurance or Non-Insurance Prescriptions
                  </p>
                </div>
              </div>
            </div>
          </Link>
          <Link
            to={"/upload-prescription/nonValid-prescription"}
            className="w-[37%]"
            id="non-valid-prescription-link"
          >
            <div className="rounded-lg w-full p-2 border border-[#004B45] cursor-pointer hover:shadow-lg transition duration-300 flex justify-center">
              <div className="flex items-center gap-3 xl:gap-4">
                <div className="h-[70px] lg:h-[3.8vw] w-[70px] lg:w-[3.8vw] bg-gradient-to-b from-[#004B45] to-[#007F77] rounded-full flex justify-center items-center text-white">
                  <img src={Group1} alt="icon" className="h-[50%] object-contain" />
                </div>
                <div className="text-left">
                  <h3 className="font-size-22px text-[#3B3B3B] font-Lexend-Regular">
                    I don't have a Prescription
                  </h3>
                  <p className="font-size-14px text-[#3B3B3B] font-Poppins-Regular">
                    Upload any Image or Tell us what you are looking for
                  </p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <h3 className="flex justify-center text-[#004540] font-Lexend-SemiBold text-[35px]">
          How it works?
        </h3>
        <div className="flex flex-col md:flex-row justify-center items-center lg:gap-[3vw] gap-4 mt-4 mb-8">
          {dt.map((item, index) => (
            <div
              className="text-center flex flex-col items-center justify-center"
              key={index}
            >
              <div className="flex justify-center lg:mb-[0.5vw] mb-1">
                <img src={item.image} alt="how it works" className="h-[40px] xl:h-[2.8vw]" />
              </div>
              <p className="font-size-18px text-[#313131] font-Poppins-Medium">
                {item.title.map((title, index) => (
                  <span key={index}>{title} {index < item.title.length - 1 && <br />}</span>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UploadPrescription;
